import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Styles } from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Container from '@mui/material/Container';
import Title from "../../../components/elements/Title";
import { Typography } from "@mui/material";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import VendorsWithFilters from "../shops/VendorsWithFilters";
import ProductsWithFilters from "../shops/ProductsWithFilters";
import MainSearchField from "../components/filters/MainSearchField";
import { setStore, connect } from "trim-redux";

function SearchPage({ classes, industry, setting }) {
    const { t } = useTranslation();
    const location = useLocation();
    const [totalRes, setTotalRes] = useState(null);
    const [search, setSearch] = useState('');
    const productMode = setting?.search_engine_mode === 'product';

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const searchTerm = queryParams.get('q') || '';
        setSearch(searchTerm);

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });

        setStore({
            global_menu: industry
        });
    }, [location.search, industry]);

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('searchFor') + (!!search ? (' "' + search + '" ') : "")}>
            <div className="page-color-layout">
                <>
                    <section className="category-page-top">
                        <Container maxWidth="xl">
                            <Grid container spacing={2}>
                                <Grid item size={12}>
                                    <div className="infos">
                                        <div className="informations">
                                            <Title component="h1" align="left" color="text" className="page-title">{t('searchFor') + (!!search ? (' "' + search + '" ') : "")}</Title>
                                            <BreadCrumbs
                                                front
                                                firstText={t(industry)}
                                                firstLink={`/${industry}`}
                                                secondText={t('searchFor') + (!!search ? (' "' + search + '" ') : "")}
                                            />
                                        </div>
                                        {
                                            (!!totalRes && totalRes > 0) &&
                                            <Typography className="results">{totalRes} {t(totalRes === 1 ? 'resultFound' : 'resultsFound')}</Typography>
                                        }

                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </section>
                    <Container maxWidth="xl">
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                                <MainSearchField inside industry={industry} search={search} />
                            </Grid>
                            {
                                !!search ?
                                <Grid item size={{ xs: 12 }}>
                                    {productMode ? (
                                        <ProductsWithFilters industry={industry} search={search} setTotal={setTotalRes} />
                                    ) : (
                                        <VendorsWithFilters industry={industry} search={search} setTotal={setTotalRes} />
                                    )}
                                </Grid>
                                    :
                                <Grid item size={{ xs: 12 }} style={{height:400}}>

                                </Grid>
                            }

                        </Grid>
                    </Container>

                </>
            </div>
        </AppAnimate>
    );
}

const mapStateToProps = (state) => ({
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(SearchPage));
